var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1916 13.607C24.2213 13.6024 24.2517 13.6001 24.2826 13.6001H24.6449C26.8193 13.6001 28.8704 14.6067 30.1872 16.3239L31.7761 18.3962C31.9728 18.6526 31.931 19.0187 31.6817 19.2242L28.8202 21.5834C28.5707 21.7891 28.2032 21.7601 27.989 21.518L27.9257 21.4463V30.4001C27.9257 30.7315 27.657 31.0001 27.3257 31.0001H16.8333C16.502 31.0001 16.2333 30.7315 16.2333 30.4001V21.4463L16.17 21.518C15.9599 21.7555 15.6011 21.7886 15.3512 21.5933L12.3307 19.2341C12.2042 19.1354 12.1226 18.9901 12.104 18.8307C12.0855 18.6713 12.1315 18.5112 12.2319 18.386L13.9788 16.2067C15.2998 14.5589 17.3074 13.6001 19.4292 13.6001H19.7418C19.7468 13.6 19.7518 13.6 19.7568 13.6001H19.8764C19.9584 13.6001 20.037 13.6167 20.1087 13.6468C20.2292 13.6684 20.3556 13.6942 20.4799 13.7196C20.5823 13.7406 20.6833 13.7612 20.7787 13.779C21.1258 13.8437 21.5243 13.9001 22 13.9001C22.4744 13.9001 22.8455 13.844 23.1553 13.7809C23.2696 13.7576 23.371 13.7344 23.4726 13.7112L23.4726 13.7112L23.4727 13.7112C23.5143 13.7016 23.5559 13.6921 23.5985 13.6826C23.7362 13.6517 23.8858 13.6202 24.0338 13.6038C24.0876 13.5978 24.1405 13.5991 24.1916 13.607ZM22 15.1001C22.509 15.1001 22.9228 15.0462 23.2644 14.9823C22.9686 15.2925 22.5483 15.4875 22.0795 15.4875C21.6307 15.4875 21.2262 15.3087 20.933 15.0212C21.2434 15.0664 21.5977 15.1001 22 15.1001ZM14.9151 16.9573C16.0022 15.6012 17.6553 14.8065 19.4079 14.8001C19.7911 15.9016 20.8453 16.6875 22.0795 16.6875C23.3133 16.6875 24.3673 15.902 24.7508 14.8011C26.5153 14.833 28.1684 15.6632 29.2349 17.0541L30.4715 18.6667L28.504 20.2889L27.7751 19.4647C27.6099 19.2779 27.3463 19.2128 27.1131 19.3011C26.8799 19.3895 26.7257 19.6128 26.7257 19.8622V29.8001H17.4333V19.8622C17.4333 19.6128 17.2791 19.3895 17.0459 19.3011C16.8127 19.2128 16.5491 19.2779 16.3839 19.4647L15.645 20.3002L13.5482 18.6624L14.9151 16.9573Z",
    fill: "url(#paint0_linear_1392_6306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9 19.0001C22.9 18.6687 23.1686 18.4001 23.5 18.4001H24.85C25.1814 18.4001 25.45 18.6687 25.45 19.0001C25.45 19.3315 25.1814 19.6001 24.85 19.6001H23.5C23.1686 19.6001 22.9 19.3315 22.9 19.0001Z",
    fill: "url(#paint1_linear_1392_6306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_6306",
    x1: 22,
    y1: 13.6,
    x2: 22,
    y2: 31.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_6306",
    x1: 24.175,
    y1: 18.4001,
    x2: 24.175,
    y2: 19.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear);
export default __webpack_public_path__ + "static/media/wear.e3000f0579263965cb1c041368a4e7e9.svg";
export { ForwardRef as ReactComponent };